import { GRAPHQL_NICHE_MUTATIONS, GRAPHQL_NICHE_QUERIES } from 'graphql/niche'
import type {
  TNicheQueriesName,
  TNicheQueriesData,
  TNicheQueriesVariables,
  TNicheMutationsName,
  TNicheMutationsVariables,
  TNicheMutationsData,
} from 'graphql/niche/types'
import { buildMutationHook, buildQueryHook } from 'lib/apollo-client/builders'

export const useNicheQueries = buildQueryHook<TNicheQueriesName, TNicheQueriesVariables, TNicheQueriesData>(
  GRAPHQL_NICHE_QUERIES
)

export const useNicheMutations = buildMutationHook<TNicheMutationsName, TNicheMutationsVariables, TNicheMutationsData>(
  GRAPHQL_NICHE_MUTATIONS
)
